//#region ../../packages/types/src/product-type.ts
var e = {
	desktopPrinter: "Desktop Printers",
	tabletopPrinter: "Tabletop Printers",
	mobilePrinter: "Mobile Printers",
	thermalRibbon: "Thermal Ribbons",
	courierLabel: "Courier Labels",
	thermalBlank: "Thermal Blanks",
	nurseryTag: "Nursery Tags",
	pharmacyLabel: "Pharmacy Labels",
	laserSheet: "Laser Sheets",
	ipaWipes: "IPA Wipes",
	software: "Software",
	rewindersApplicators: "Rewinders & Applicators",
	scanner: "Scanners",
	bundle: "Bundles"
}, t = "Use the current product page, catalogue, cart and recent shopping activity. Recommend relevant product first. Briefly explain relevance or suitability grounded in catalogue facts. Ask clarifying questions (if necessary) then ask to add product(s) to cart.", n = "(Post Haste, Mainfreight, PBT, CourierPost, GoSweetSpot)", r = "Ensure compatible width, core and roll diameter.", i = "Ensure compatible printhead, width, length and winding.", a = {
	question: "Essentials.",
	prompt: "Recommend products necessary to maintain {product} or to improve quality and efficiency of industrial, agricultural dispatch, packing and labeling workflows."
}, o = {
	question: "Compatible labels.",
	prompt: "Find compatible labels for {product}. " + r
}, s = {
	question: "Courier labels.",
	prompt: `List NZ courier services ${n}. Select courier labels compatible with courier service and {product}. ${r}`
}, c = {
	question: "Is this suitable for...",
	prompt: "I intend to {workflow}. Assess suitability of {product} for intended workflow ie. retail, agricultural, dispatch."
}, l = {
	question: "Complete dispatch workflow.",
	prompt: "Recommend product bundle and/or printer, consumables and accessories for my intended dispatch workflow."
}, u = Object.freeze({
	[e.desktopPrinter]: [
		o,
		s,
		a
	],
	[e.tabletopPrinter]: [
		o,
		s,
		{
			question: "Compatible ribbons.",
			prompt: `List compatible ribbons for {product}. ${i}`
		},
		a
	],
	[e.mobilePrinter]: [
		o,
		{
			question: "Mobility & charging.",
			prompt: "List compatible power, charging and carrying accessories for {product}."
		},
		c
	],
	[e.thermalRibbon]: [{
		question: "Compatible printers.",
		prompt: `Find compatible printer(s) for {product}. ${i}`
	}, {
		question: "Compatible labels.",
		prompt: "Find compatible labels for {product}. Ensure compatible finish and adhesive."
	}],
	[e.courierLabel]: [{
		question: "Courier accepted?",
		prompt: `For NZ courier services ${n}, check {product} is accepted by the courier service(s) I engage.`
	}, l],
	[e.thermalBlank]: [
		{
			question: "Compatible printers.",
			prompt: "Find compatible printers and required ribbons for {product}. Ensure compatible print method, width, core and roll diameter."
		},
		l,
		c
	],
	[e.nurseryTag]: [
		{
			question: "Agricultural & Nursery workflows.",
			prompt: "Assess {product} for outdoor nursery and horticultural use. Suggest a better option if needed."
		},
		l,
		{
			question: "Compatible printers.",
			prompt: "Find compatible printers and required ribbons for {product}. Ensure compatible print method, width, core and roll diameter."
		}
	],
	[e.pharmacyLabel]: [{
		question: "Compatible printers.",
		prompt: "Find compatible printers and required ribbons for {product}. Ensure compatible print method, width, core and roll diameter."
	}, l],
	[e.laserSheet]: [
		{
			question: "Compatible printers.",
			prompt: "Find compatible printers and required ribbons for {product}. Ensure compatible print method and dimensions."
		},
		c,
		a
	],
	[e.ipaWipes]: [c, a],
	[e.software]: [{
		question: "Compatible printers.",
		prompt: "Find compatible printers for {product}. Identify licensing constraints or operating system requirements."
	}],
	[e.rewindersApplicators]: [c, a],
	[e.scanner]: [
		c,
		a,
		l
	],
	[e.bundle]: [c]
}), d = class extends HTMLElement {
	connectedCallback() {
		let e = u[this.dataset.productType];
		if (!e?.length) return;
		let t = this.querySelector(".agent-query__list");
		if (t) {
			if (t.childElementCount > 0) {
				this.hidden = !1;
				return;
			}
			for (let n of e) {
				let e = document.createElement("button");
				e.className = "agent-query__chip", e.type = "button", e.textContent = n.question, e.addEventListener("click", () => this.send(n.prompt, e)), t.append(e);
			}
			this.hidden = !1;
		}
	}
	async send(e, n) {
		let r = document.querySelector("shopify-chat"), i = this.querySelector(".agent-query__status"), a = `"${this.dataset.productTitle}" (SKU: ${this.dataset.sku})`, o = `${e.replaceAll("{product}", a)}\n\n${t}`;
		n.disabled = !0;
		try {
			if (typeof r?.sendStarterMessage != "function") throw Error("Shopify Agent unavailable");
			await r.sendStarterMessage(o, "suggestion_pill");
		} catch {
			r?.show?.(), i && (i.hidden = !1, i.textContent = "Open Chat to ask this question.");
		} finally {
			n.disabled = !1;
		}
	}
};
//#endregion
//#region assets/agent-query/index.js
customElements.get("agent-query") || customElements.define("agent-query", d);
//#endregion
